import React from 'react';
import VariantPicker from './components/VariantPicker';
import { SettingsContext, TranslationContext } from './components/Context';

const VariantPickerApp = props => {
    return (
        <SettingsContext.Provider value={
            {
                selectedsku: props.SelectedSku ? props.SelectedSku : null,
                skuoptions: props.SkuOptions ? props.SkuOptions : [],
                selections: [],
                skudata: [],
                contextitemid: props.ContextItemId,
                language: props.Language,
                isEDometicContext: props.IsEDometicContext,
                renderb2bbuyarea: props.RenderB2BBuyArea,
                renderAddToCart: props.RenderAddToCart,
                similarImageSvg: props.SimilarImageSvg,
                cartUrl: props.CartUrl
            }
        }
        >
            <TranslationContext.Provider value={props.Translations}>
                <VariantPicker
                    selectedSku={props.SelectedSku}
                    attributes={props.Attributes}
                    modelTitle={props.ModelTitle}
                    modelText={props.ModelText}
                    imageUrl={props.ImageUrl}
                    imageAlt={props.ImageAlt}
                    promotionBadge={props.PromotionBadge}
                />
            </TranslationContext.Provider>
        </SettingsContext.Provider >
    );
};

export default VariantPickerApp;